import type { RouterConfig } from "@nuxt/schema";
// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
	routes: routes => [
		...routes,
		{
			name: "orders-order",
			path: "/orders/:order",
			component: () => import("~/pages/orders/[order].vue")
		},
		{
			name: "shippings-shipping",
			path: "/shippings/:shipping",
			component: () => import("~/pages/shippings/[shipping].vue")
		},
		{
			name: "shippings-shipping-shipping-history-history",
			path: "/shippings/:shipping/shipping-history/:history",
			component: () => import("~/pages/shippings/shipping-history/[history].vue")
		},
		{
			name: "payments-payment",
			path: "/payments/:payment",
			component: () => import("~/pages/payments/[payment].vue")
		},
		{
			name: "payments-payment-payment-history-history",
			path: "/payments/:payment/payment-history/:history",
			component: () => import("~/pages/payments/payment-history/[history].vue")
		},
		{
			name: "components-kinds-kind",
			path: "/components/kinds/:kind",
			component: () => import("~/pages/components/kinds/[kind].vue")
		},
		{
			name: "components-kinds-create",
			path: "/components/kinds/create",
			component: () => import("~/pages/components/kinds/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "components-colors-color",
			path: "/components/colors/:color",
			component: () => import("~/pages/components/colors/[color].vue")
		},
		{
			name: "components-colors-create",
			path: "/components/colors/create",
			component: () => import("~/pages/components/colors/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "components-sizes-size",
			path: "/components/sizes/:size",
			component: () => import("~/pages/components/sizes/[size].vue")
		},
		{
			name: "components-sizes-create",
			path: "/components/sizes/create",
			component: () => import("~/pages/components/sizes/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "components-materials-material",
			path: "/components/materials/:material",
			component: () => import("~/pages/components/materials/[material].vue")
		},
		{
			name: "components-materials-create",
			path: "/components/materials/create",
			component: () => import("~/pages/components/materials/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "components-materials-edit-material",
			path: "/components/materials/edit/:material",
			component: () => import("~/pages/components/materials/edit/[material].vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "products-item-prototypes-prototype",
			path: "/products/item-prototypes/:prototype",
			component: () => import("~/pages/products/item-prototypes/[prototype].vue")
		},
		{
			name: "products-item-prototypes-create",
			path: "/products/item-prototypes/create",
			component: () => import("~/pages/products/item-prototypes/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "products-item-prototypes-edit-prototype",
			path: "/products/item-prototypes/edit/:prototype",
			component: () => import("~/pages/products/item-prototypes/edit/[prototype].vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "products-item-prototypes-prototype-items-item",
			path: "/products/item-prototypes/:prototype/items/:item",
			component: () => import("~/pages/products/item-prototypes/items/[item].vue")
		},
		{
			name: "products-item-prototypes-prototype-items-create",
			path: "/products/item-prototypes/:prototype/items/create",
			component: () => import("~/pages/products/item-prototypes/items/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "products-item-prototypes-prototype-items-edit",
			path: "/products/item-prototypes/:prototype/items/edit",
			component: () => import("~/pages/products/item-prototypes/items/edit.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "products-tags-tag",
			path: "/products/tags/:tag",
			component: () => import("~/pages/products/tags/[tag].vue")
		},
		{
			name: "products-tags-create",
			path: "/products/tags/create",
			component: () => import("~/pages/products/tags/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "products-collections-collection",
			path: "/products/collections/:collection",
			component: () => import("~/pages/products/collections/[collection].vue")
		},
		{
			name: "products-collections-create",
			path: "/products/collections/create",
			component: () => import("~/pages/products/collections/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "customers-customer-customer-history-history",
			path: "/customers/:customer/customer-history/:history",
			component: () => import("~/pages/customers/customer-history/[history].vue")
		},
		{
			name: "price-policies-create",
			path: "/price-policies/create",
			component: () => import("~/pages/price-policies/create.vue"),
			meta: {
				layout: "publish"
			}
		},
		{
			name: "price-policies-edit-policy",
			path: "/price-policies/edit/:policy",
			component: () => import("~/pages/price-policies/edit/[policy].vue"),
			meta: {
				layout: "publish"
			}
		}
	]

};
